import { render, staticRenderFns } from "./zswiperItem.vue?vue&type=template&id=1955317d&scoped=true"
import script from "./zswiperItem.vue?vue&type=script&lang=js"
export * from "./zswiperItem.vue?vue&type=script&lang=js"
import style0 from "./zswiperItem.vue?vue&type=style&index=0&id=1955317d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1955317d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1955317d')) {
      api.createRecord('1955317d', component.options)
    } else {
      api.reload('1955317d', component.options)
    }
    module.hot.accept("./zswiperItem.vue?vue&type=template&id=1955317d&scoped=true", function () {
      api.rerender('1955317d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/homePage/components/zswiperItem.vue"
export default component.exports